import { Button } from "shared/components/Button";
import { Checkbox } from "shared/components/Checkbox";
import {
  COOKIE_ADVERTISING_MESSAGE,
  COOKIE_ANALYTICS_MESSAGE,
  COOKIE_FUNCTIONAL_MESSAGE,
  COOKIE_SUBMIT,
  translate,
} from "shared/utils/translate";
import { useAppContext } from "shared/utils/useAppContext";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import styles from "./CookieSettings.module.css";

export const CookieSettings = () => {
  const { cookies } = useAppContext();
  const router = useRouter();
  const { advertising, analytics, functional, setAdvertising } = cookies;
  const [tmpAdvertising, setTmpAdvertising] = useState(advertising);

  function onAdvertisingChange(e) {
    setTmpAdvertising(e.target.checked ? 1 : 0);
  }

  function save() {
    setAdvertising(tmpAdvertising);
    if (router.query?.redirect) router.back();
  }

  useEffect(() => {
    setTmpAdvertising(advertising);
  }, [advertising]);

  return (
    <div className={styles.container}>
      <Checkbox
        disabled
        checked={functional}
        label={translate(COOKIE_FUNCTIONAL_MESSAGE, router.locale)}
      />
      <Checkbox
        disabled
        checked={analytics}
        label={translate(COOKIE_ANALYTICS_MESSAGE, router.locale)}
      />
      <Checkbox
        checked={tmpAdvertising}
        label={translate(COOKIE_ADVERTISING_MESSAGE, router.locale)}
        onChange={onAdvertisingChange}
      />

      <Button
        onClick={save}
        disabled={Boolean(tmpAdvertising) === Boolean(advertising)}
      >
        {translate(COOKIE_SUBMIT, router.locale)}
      </Button>
    </div>
  );
};
